import { useAccount } from 'wagmi'
import { usePositionNames } from '@/domain/state'

export function getPositionLabel(subAccountId: number, customName?: string): string {
  return customName || `Position ${subAccountId}`
}

export function usePositionName(subAccountId: number) {
  const { address } = useAccount()
  const { getPositionName, setPositionName, clearPositionName } = usePositionNames()

  const customName = getPositionName(address, subAccountId)
  const name = getPositionLabel(subAccountId, customName)

  return {
    name,
    isCustom: !!customName,
    setName: (newName: string) => {
      if (address) setPositionName(address, subAccountId, newName)
    },
    clearName: () => {
      if (address) clearPositionName(address, subAccountId)
    },
  }
}
